import {Injectable} from '@angular/core';
import {
   ActivatedRoute,
   ActivatedRouteSnapshot,
   CanActivate,
   Router,
   RouterStateSnapshot,
   UrlTree
} from '@angular/router';
import {parallel, waterfall} from 'async';
import {DataService} from "../services/data.service";
import * as moment from 'moment';
import {UserFactory} from "../models/User";
import {environment} from "../../environments/environment";
import {EsercizioFactory} from "../models/Esercizio";
import {NgxSpinnerService} from "ngx-spinner";
import {loadMessages, locale} from 'devextreme/localization';
import {registerLocaleData} from '@angular/common';
import config from "devextreme/core/config";
import dxIt from '../../assets/i18n/devextreme-it.json';
import localeIt from '@angular/common/locales/it';
import {EsercizioUtenteFactory} from "../models/EsercizioUtente";
import {ServerService} from "../services/server.service";
import {Piano} from "../models/Piano";
import {BadgeService} from "../services/badge.service";
import {PVenditaUtenteFactory} from "../models/PVenditaUtente";


class Functions{
   public static initLanguage(){
      console.log("* initLanguage")
      moment.locale('it');
      registerLocaleData(localeIt);
      locale('it');
      loadMessages(dxIt);
      config({ defaultCurrency: "EUR" });
   }
}


@Injectable({
   providedIn: 'root'
})
export class AuthGuard implements CanActivate {

   constructor(private dataSrv: DataService,
               private spinner: NgxSpinnerService,
               private userFactory: UserFactory) {  }

   canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): Promise<boolean | UrlTree> | boolean | UrlTree {
      console.log("=== AuthGuard ===")

      return new Promise((resolve, reject) => {
         waterfall([
            (next:any)=>{
               this.userFactory.getInfo().then((user)=> {
                  this.dataSrv.user = user
                  next(null);
               }).catch(err=>next(err))
            },
            // (next:any)=>{
            //    this.userFactory.getDashboardData().then(()=> next(null)).catch(err=> next(err));
            // }
         ], err => {
            this.spinner.hide();
            if(err){
               console.error("Impossibile andare avanti...")
               console.error(err)
               window.location.href = environment.loginPath;
               resolve(false);
            }else{
               Functions.initLanguage()
               resolve(true);
            }
            console.groupEnd()
         })
      })
   }
}


@Injectable({
   providedIn: 'root'
})
export class AuthGuardAdmin implements CanActivate {

   constructor(private dataSrv: DataService,
               private spinner: NgxSpinnerService,
               private badgeSrv: BadgeService,
               private userFactory: UserFactory) {  }

   canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): Promise<boolean | UrlTree> | boolean | UrlTree {
      console.group("=== AuthGuardAdmin ===")

      this.dataSrv.vendorSlug = undefined

      return new Promise((resolve, reject) => {
         this.userFactory.getInfo().then(res => {
            this.dataSrv.user = res
            this.badgeSrv.getBadgeCount()

            if (res.IsAdmin){
               this.spinner.hide()
               Functions.initLanguage()
               console.groupEnd()
               return resolve(true)

            }else {
               console.error("Impossibile andare avanti...")
               console.error()
               window.location.href = environment.loginPath;
               this.spinner.hide();
               console.groupEnd()
               resolve(false);
            }

         }).catch(err => {
            console.groupEnd()
            window.location.href = environment.loginPath;
            resolve(false);
         }).finally(()=>{

         })
      })
   }

}


@Injectable({
   providedIn: 'root'
})
export class AuthGuardEsercizio implements CanActivate {

   /**
    * Auth guard dell'esercizio
    */

   constructor(private dataSrv: DataService,
               private serverSrv: ServerService,
               private spinner: NgxSpinnerService,
               private router: Router,
               private activatedRoute: ActivatedRoute,
               private esercizioFactory: EsercizioFactory,
               private esercizioUtenteFactory: EsercizioUtenteFactory,
               private pVenditaUsrFctr: PVenditaUtenteFactory) {}

   canActivate( route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> | boolean | UrlTree {
      console.group("=== AuthGuardEsercizio ===")
      this.dataSrv.vendorSlug = route.params["esercizio_slug"]
      return new Promise(async (resolve, reject) => {
         let user_id;
         if(this.dataSrv.user.IsAdmin){
            let esercizio = await this.esercizioFactory.getEsercizio(route.params['esercizio_slug'])
            user_id = esercizio.data.amministratore.id
         }else{
            user_id = this.dataSrv.user.ID
         }

         parallel([

            // esercizi utente
            (next)=>{
               this.esercizioUtenteFactory.getEserciziUtente(user_id).then(res=>{
                  this.dataSrv.eserciziUser = res
                  next(null)
               }).catch((err)=>{
                  next(err)
               })
            },

            // esercizio utente
            async (next)=>{
               this.esercizioUtenteFactory.getEsercizioUtente(user_id, route.params['esercizio_slug'])
                  .then(res=>{
                     this.dataSrv.esercizioUser = res

                     // if (!res.esercizio.data.is_approvato && !this.dataSrv.user.IsStaff){
                     //    window.location.replace(environment.loginPath)
                     // }

                     this.pVenditaUsrFctr.getPVenditaUtenti(user_id, this.dataSrv.esercizioUser.ID).then((ris) => {
                        this.dataSrv.puntiVendita = ris;
                        next(null)
                     }).catch(err => {
                        next(err)
                     })
                  })
                  .catch(err=>{
                     next(err)
                  })
            },
            // Check piano
            async (next)=>{
               this.serverSrv.get(null, `/api/esercizi/${route.params['esercizio_slug']}/checklicenza`)
                  .then(res=>{
                     if (res.piano) this.dataSrv.pianoAttivoEsercizio = new Piano(res.piano)
                     console.log(this.dataSrv.pianoAttivoEsercizio)
                     console.log(res)
                     console.log(res.warnings)
                     this.dataSrv.errors_plan = res.errors
                     this.dataSrv.warnings = res.warnings
                     this.dataSrv.plan_is_valid = res.piano_is_valid
                     this.dataSrv.show_shopify = res.show_shopify
                     this.dataSrv.plan_is_demo = res.is_piano_demo

                     if (res.errors.lenght > 0){

                     }

                     if (this.dataSrv.user.IsStaff){
                        next(null)
                     }
                     else {
                        if (res.piano_exist) {
                           next(null)
                        }
                        else if (res.is_piano_demo) {
                           this.router.navigate([`/ng/register/esercizi/${route.params['esercizio_slug']}`])
                        }
                        else {
                           this.router.navigate([`/ng/pricing/esercizi/${route.params['esercizio_slug']}`])
                        }
                     }

                  })
                  .catch(err=>{
                     next(err)
                  })
            },
         ], (err)=>{
            this.spinner.hide();
            if(err){
               console.error(err)
               reject(err)
            }else{
               resolve(true);
            }
            console.groupEnd()
         })
      })
   }

}
